import { SortType } from '../enums';

export const SortTypes = [SortType.IDLE, SortType.ASC, SortType.DESC];
